module.exports = "/_next/static/images/step1-aa5400dc8f059b973d3e545f4c592ec7.svg";